// extracted by mini-css-extract-plugin
export var content = "_9i-3";
export var list = "_9i-4";
export var settingsContent = "_9i-7";
export var settingsPanel = "_9i-8";
export var state = "_9i-6";
export var triggerBadge = "_9i-2";
export var triggerButton = "_9i-1";
export var triggerShell = "_9i-0";
export var unreadDot = "_9i-5";